import Vue from 'vue';
import {ApckPortletApexChart} from "../portlet";

export const ApckPortletImpact = /*#__PURE__*/ ApckPortletApexChart.extend({
    props: {
        ctype: {
            type: String,
            default: "impactportlet"
        },
        title: {
            type: String,
            default: "Impact Chart"
        },
        size: {
            type: String,
            default: "md"
        },
        description: {
            type: String,
            default: "Shows a chart of all vulnerabilities discovered by impact and probability"
        },
        src: {
            type: String,
            default: "/impact"
        },
        chartType: {
            type: String,
            default: 'bar',
        },
        defaultChartOptions: {
            type: Object,
            default: function () {
                return {
                    chart: {
                        stacked: true,
                        toolbar: {
                            tools: {
                                download: false,
                            },
                        },
                    },
                    legend: {
                        show: false
                    },
                    labels: ['Critical', 'High', 'Medium', 'Low'],
                    dataLabels: {
                        enabled: false,
                    },
                    stroke: {
                        width: 1,
                        colors: ["#fff"]
                    },
                    fill: {
                        opacity: 1,
                    },
                    grid: {
                        xaxis: {
                            lines: {
                                show: true
                            }
                        },
                        yaxis: {
                            lines: {
                                show: true
                            }
                        },
                    },
                    states: {
                        active: {
                            filter: {
                                type: 'none'
                            }
                        },
                        hover: {
                            filter: {
                                type: 'none',
                            }
                        },
                    },
                }
            }
        },
    },
    created() {
        const cmp = this;

        const labelMap = {
            'critical': '5.0-critical',
            'high': '4.0-high',
            'medium': '3.0-medium',
            'low': '2.0-low',
            'info': '1.0-info',
        };
        const categoryMap = {
            'all': 'all',
            'app': 'web_app',
            'infra': 'infra',
        };

        // register chart click actions
        const events = {
            dataPointSelection: function (event, chartContext, opts) {
                const selectedLabel = opts.w.config.labels[opts.dataPointIndex];
                const params = new URLSearchParams({
                    impact: labelMap[selectedLabel.toLowerCase()],
                    status: cmp.options.mode.value === 'all' ? 'all' : 'unfixed',
                    category: categoryMap[cmp.options.type.value],
                });
                const href = '/vulnerabilities?' + params.toString();
                window.open(href, '_blank').focus();
            }
        };

        this.chartOptions.chart = this.chartOptions.chart || {};
        this.chartOptions.chart.events = {...this.chartOptions.chart.events, ...events};
    },
    methods: {
        parseData: function(data) {
            this.chartSeries = data.data;
        },
    },
    data: function () {
        return {
            options: {
                mode: {
                    label: "Mode",
                    type: "select",
                    default: "unfixed",
                    choices: [{
                        label: "Count only unresolved vulnerabilities",
                        value: "unfixed"
                    }, {
                        label: "Count all vulnerabilities",
                        value: "all"
                    }]
                },
                type: {
                    label: "Type",
                    type: "select",
                    default: "all",
                    choices: [{
                        label: "All",
                        value: "all"
                    }, {
                        label: "Application",
                        value: "app"
                    }, {
                        label: "Infrastructure",
                        value: "infra"
                    }]
                }
            }
        };
    },
});
